 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0988f53e":"04798d9d","chunk-20266b9a":"0e2d9c80","chunk-248a6e76":"e4ada292","chunk-2ce50ab6":"a3bde3c4","chunk-2d0aa5b8":"49be9d2d","chunk-284a7416":"3c8d3822","chunk-6a7a5756":"7b629713","chunk-2d0d7664":"829401e9","chunk-2d0e22e8":"d7d3af8b","chunk-2d210457":"2f0f11b5","chunk-2d21083d":"9bfe381c","chunk-2d21b4fa":"44de8302","chunk-30fd3370":"ac4e76d0","chunk-3ac0660d":"c492e641","chunk-42a51120":"06d6fc3a","chunk-44382ae8":"5adad70a","chunk-11b41d33":"b517dcb8","chunk-22530257":"ded29ead","chunk-5034f901":"65ea5054","chunk-6fc9dac4":"47e1b92b","chunk-746610ea":"646d8141","chunk-9ad2df88":"34011329","chunk-a0d3aaec":"e45459e5","chunk-a1baad00":"b05bbec0","chunk-c8a023b2":"7595ac7d","chunk-c98be466":"2eb565e7","chunk-dde50376":"28e5a9c0","chunk-f787390e":"b1595a94","chunk-2d0aa8de":"2ecc0d78","chunk-3645b65d":"232e6aad","chunk-2d0aecab":"af5d81a8","chunk-157255ed":"4c36f9a0","chunk-1e857e38":"3a2df3d3","chunk-2d0c8667":"a601667b","chunk-2d2132c0":"685f8e0b","chunk-38f4c13f":"54e3f607","chunk-585e6b20":"1107c300","chunk-7b5ad112":"daae4979","chunk-d651dca0":"e060be6c","chunk-2d22c6d2":"e7f22ad4","chunk-dc464020":"a90ade2f","chunk-09f7401e":"12129d37","chunk-e61d9a42":"ecf478b7","chunk-02911059":"9a71e7ad","chunk-03b4662c":"bca53538","chunk-040e201b":"d7df28ab","chunk-06462324":"eba044e9","chunk-13f1acc4":"7cb2aa43","chunk-177a15b8":"ee7c96af","chunk-183a9348":"005f0105","chunk-199e03f4":"3924f97e","chunk-1b797cc0":"7d200dc5","chunk-20994083":"210da208","chunk-2630372a":"1c2f1a02","chunk-290038d2":"f0685e02","chunk-2d0ab4ea":"90f9d9eb","chunk-2d0ae964":"a90da30d","chunk-2d0af3ee":"2a090ec9","chunk-2d0b2aaf":"4c88cdd5","chunk-2d0c82ee":"93070acc","chunk-2d0d7720":"4ea591d3","chunk-2d0e9708":"2ca63aff","chunk-2d0f00a2":"6c3500dc","chunk-2d209160":"b5f9d7fa","chunk-2d209535":"6caaf0b5","chunk-2d20f188":"6c21b8c3","chunk-2d20faa6":"f986d336","chunk-2d2101fc":"e8597b39","chunk-2d2169d4":"c367afd6","chunk-2d21b0e5":"088df0b8","chunk-2d21ddd9":"93d90d83","chunk-2d2306b5":"8017e334","chunk-2d2383bd":"ea696e73","chunk-35fe0437":"864c7874","chunk-38cdc06f":"e612c368","chunk-3bdf2684":"9c009f37","chunk-3cb48816":"f42435ee","chunk-3e44ade6":"f51fd05d","chunk-45f5bb24":"af74d704","chunk-466a8779":"5d469993","chunk-47f8f819":"7e5054dc","chunk-48722b11":"bfcc3af6","chunk-4e0a5af2":"705e5149","chunk-5315eea9":"d0b24f97","chunk-5d2beaa7":"4fbce444","chunk-60010df2":"99018716","chunk-6317869c":"05762d28","chunk-63b2313f":"8b741279","chunk-6f81340c":"f2644b29","chunk-76558320":"a194181f","chunk-78624db3":"756a3908","chunk-84e045a0":"7bcb10c6","chunk-94819000":"f0397a47","chunk-a12bbf7e":"fc18a3ad","chunk-c4e2972a":"c10db87d","chunk-eaf96796":"749a6cfc","chunk-f4cf85c2":"ce863f93","chunk-2d0d38d6":"67581e24","chunk-bf981d52":"4175c4e3","chunk-2d0d61b0":"cf09248a","chunk-6dd626e4":"1ef29a8e","chunk-85295cc8":"127d9e33","chunk-2d0aacb9":"724d30c9","chunk-2d0cf2d4":"f63b275c","chunk-2d21d4d4":"87a49848","chunk-2d22d976":"66186ce0","chunk-4a222993":"130bc2db","chunk-7cfb6228":"9a5ec9b0","chunk-161220f2":"496c7b44","chunk-2d21a946":"29a36704","chunk-2d21e576":"fea16003","chunk-62545fea":"ef79ac4d","chunk-659e79cc":"24f2a3dd","chunk-2d0b7295":"3b1664bb","chunk-2d0b9650":"ef6c6621"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-20266b9a":1,"chunk-2ce50ab6":1,"chunk-284a7416":1,"chunk-6a7a5756":1,"chunk-30fd3370":1,"chunk-3ac0660d":1,"chunk-42a51120":1,"chunk-44382ae8":1,"chunk-11b41d33":1,"chunk-22530257":1,"chunk-6fc9dac4":1,"chunk-9ad2df88":1,"chunk-c98be466":1,"chunk-dde50376":1,"chunk-f787390e":1,"chunk-3645b65d":1,"chunk-157255ed":1,"chunk-1e857e38":1,"chunk-38f4c13f":1,"chunk-585e6b20":1,"chunk-7b5ad112":1,"chunk-d651dca0":1,"chunk-09f7401e":1,"chunk-e61d9a42":1,"chunk-02911059":1,"chunk-03b4662c":1,"chunk-040e201b":1,"chunk-06462324":1,"chunk-13f1acc4":1,"chunk-177a15b8":1,"chunk-183a9348":1,"chunk-199e03f4":1,"chunk-1b797cc0":1,"chunk-20994083":1,"chunk-2630372a":1,"chunk-290038d2":1,"chunk-35fe0437":1,"chunk-38cdc06f":1,"chunk-3bdf2684":1,"chunk-3cb48816":1,"chunk-3e44ade6":1,"chunk-45f5bb24":1,"chunk-466a8779":1,"chunk-47f8f819":1,"chunk-48722b11":1,"chunk-4e0a5af2":1,"chunk-5315eea9":1,"chunk-5d2beaa7":1,"chunk-60010df2":1,"chunk-6317869c":1,"chunk-63b2313f":1,"chunk-6f81340c":1,"chunk-76558320":1,"chunk-78624db3":1,"chunk-84e045a0":1,"chunk-c4e2972a":1,"chunk-eaf96796":1,"chunk-f4cf85c2":1,"chunk-bf981d52":1,"chunk-6dd626e4":1,"chunk-4a222993":1,"chunk-7cfb6228":1,"chunk-62545fea":1,"chunk-659e79cc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0988f53e":"31d6cfe0","chunk-20266b9a":"0450b522","chunk-248a6e76":"31d6cfe0","chunk-2ce50ab6":"b1ac6ce6","chunk-2d0aa5b8":"31d6cfe0","chunk-284a7416":"052ac410","chunk-6a7a5756":"14c84ab9","chunk-2d0d7664":"31d6cfe0","chunk-2d0e22e8":"31d6cfe0","chunk-2d210457":"31d6cfe0","chunk-2d21083d":"31d6cfe0","chunk-2d21b4fa":"31d6cfe0","chunk-30fd3370":"4e7c88b4","chunk-3ac0660d":"ebc9c352","chunk-42a51120":"baa55674","chunk-44382ae8":"2802891a","chunk-11b41d33":"73e9ccbd","chunk-22530257":"1bcabbda","chunk-5034f901":"31d6cfe0","chunk-6fc9dac4":"def62133","chunk-746610ea":"31d6cfe0","chunk-9ad2df88":"32c726c5","chunk-a0d3aaec":"31d6cfe0","chunk-a1baad00":"31d6cfe0","chunk-c8a023b2":"31d6cfe0","chunk-c98be466":"45dd75f8","chunk-dde50376":"5d992822","chunk-f787390e":"b6f7ff42","chunk-2d0aa8de":"31d6cfe0","chunk-3645b65d":"b7637332","chunk-2d0aecab":"31d6cfe0","chunk-157255ed":"e5a86a6a","chunk-1e857e38":"9e9e1ad6","chunk-2d0c8667":"31d6cfe0","chunk-2d2132c0":"31d6cfe0","chunk-38f4c13f":"694820f4","chunk-585e6b20":"0818dc6e","chunk-7b5ad112":"b713b5eb","chunk-d651dca0":"1893c72e","chunk-2d22c6d2":"31d6cfe0","chunk-dc464020":"31d6cfe0","chunk-09f7401e":"914d8f33","chunk-e61d9a42":"8cb98b78","chunk-02911059":"6812ae07","chunk-03b4662c":"42deae97","chunk-040e201b":"eab6f1f5","chunk-06462324":"3cb50ffc","chunk-13f1acc4":"b3a6ed4c","chunk-177a15b8":"4977d79c","chunk-183a9348":"935d0216","chunk-199e03f4":"1c9e0214","chunk-1b797cc0":"7a4050ab","chunk-20994083":"7321db04","chunk-2630372a":"c826bd9d","chunk-290038d2":"ea76aca1","chunk-2d0ab4ea":"31d6cfe0","chunk-2d0ae964":"31d6cfe0","chunk-2d0af3ee":"31d6cfe0","chunk-2d0b2aaf":"31d6cfe0","chunk-2d0c82ee":"31d6cfe0","chunk-2d0d7720":"31d6cfe0","chunk-2d0e9708":"31d6cfe0","chunk-2d0f00a2":"31d6cfe0","chunk-2d209160":"31d6cfe0","chunk-2d209535":"31d6cfe0","chunk-2d20f188":"31d6cfe0","chunk-2d20faa6":"31d6cfe0","chunk-2d2101fc":"31d6cfe0","chunk-2d2169d4":"31d6cfe0","chunk-2d21b0e5":"31d6cfe0","chunk-2d21ddd9":"31d6cfe0","chunk-2d2306b5":"31d6cfe0","chunk-2d2383bd":"31d6cfe0","chunk-35fe0437":"38825f4c","chunk-38cdc06f":"a4785727","chunk-3bdf2684":"ba1de80b","chunk-3cb48816":"15561898","chunk-3e44ade6":"cc1808b3","chunk-45f5bb24":"66a1083e","chunk-466a8779":"880e05f2","chunk-47f8f819":"e05e0a19","chunk-48722b11":"41a2c792","chunk-4e0a5af2":"ea65ff19","chunk-5315eea9":"fa1067d9","chunk-5d2beaa7":"6ed55696","chunk-60010df2":"9c36fb57","chunk-6317869c":"ce9e53ad","chunk-63b2313f":"d51880e6","chunk-6f81340c":"5097d29c","chunk-76558320":"ffc8b208","chunk-78624db3":"5a4d46a9","chunk-84e045a0":"8cf49635","chunk-94819000":"31d6cfe0","chunk-a12bbf7e":"31d6cfe0","chunk-c4e2972a":"d2d295e4","chunk-eaf96796":"0749ac0b","chunk-f4cf85c2":"07b7c8f8","chunk-2d0d38d6":"31d6cfe0","chunk-bf981d52":"b7f79635","chunk-2d0d61b0":"31d6cfe0","chunk-6dd626e4":"5b76a287","chunk-85295cc8":"31d6cfe0","chunk-2d0aacb9":"31d6cfe0","chunk-2d0cf2d4":"31d6cfe0","chunk-2d21d4d4":"31d6cfe0","chunk-2d22d976":"31d6cfe0","chunk-4a222993":"c308b4de","chunk-7cfb6228":"a134cd26","chunk-161220f2":"31d6cfe0","chunk-2d21a946":"31d6cfe0","chunk-2d21e576":"31d6cfe0","chunk-62545fea":"1a457e8e","chunk-659e79cc":"71f57cbc","chunk-2d0b7295":"31d6cfe0","chunk-2d0b9650":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-projects-build.joinnus.com/jland-prime/production/1984/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
